import { Card } from './FormCard.styles';
import type { FormCardProps } from './FormCard.types';

export function FormCard({ children }: FormCardProps) {
  return <Card>{children}</Card>;
}
